import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Form from "../../components/form/Form";

const DeleteProjectGroupModal = ({group, groups = [], ...props}) => {

    const availableGroups = TB.filter(groups, g => g.id !== group.id);
    const [formModel, setFormModel] = useState({new_group: false});


    const canTransferProjects = group.projects_count > 0 && availableGroups.length > 0

    const formFields = () => {

        let fields = {
            new_group: {
                type: 'checkbox',
                label: 'Assign projects to another group?',
                required: false
            },
        };

        if (formModel.new_group) {
            fields.new_group_id = {
                    type: 'select',
                    label: "Select group",
                    options:  [{
                        label: 'Select Group',
                        value: '',
                        disabled: true
                    }].concat(TB.reduce(availableGroups, (options, g) => {
                        options.push({
                            label:g.name, value:g.id
                        })
                        return options
                    }, [])),
                    required: true
            };
        }
        return [
            {
                fields
            },
        ]
    }


    return (
        <div className="flex items-stretch flex-col">

            <p>Are you sure you want to delete this group?</p>

            {canTransferProjects && (
                <p className="text-danger text-italic">
                    <small>
                        Note: This groups has <b>active projects</b>. <br/>
                        If you would like to transfer the projects to another group, click the checkbox below. Otherwise the projects will be publicly available to view within your organization.
                    </small>
                </p>
            )}
            {canTransferProjects && (
                <Form
                    className="project-group-from"
                    onChange={(model) => setFormModel({...formModel, ...model})}
                    fields={formFields()}
                    model={formModel}
                    submitButton={false}
                    cancelButton={false}
                    isDisabled={props.disabled}/>
            )}
            <div className="mt-5 flex justify-end">
                <button onClick={() => props.onRequestClose()} disabled={props.disabled} className="btn btn-dark mr-2 ml-auto">
                    Cancel
                </button>
                <button disabled={props.disabled}
                        onClick={() => props.onDelete(group, formModel)}
                        className="btn btn-primary">
                    {canTransferProjects ? 'Submit' : 'Yes, Continue'}
                </button>
            </div>
        </div>
    );
};

DeleteProjectGroupModal.propTypes = {
    group: PropTypes.any,
    groups: PropTypes.any,
    disabled: PropTypes.any,
    onDelete: PropTypes.func,
    onRequestClose: PropTypes.func
};

export default DeleteProjectGroupModal;